import React from "react"
import BusinessEmailBlock from "../hosting/BusinessEmailBlock"

const EmailBlock = () => {
  return (
      <section className="pricing text-start bg-white">
        <div className="container-xl">
          <h3 className="mb-4 component-title text-dark-blue">
            Elevate Your Business Communications
          </h3>
          <div className="row">
            <div className="col-12 col-lg-8">
              <div className="description">
                <ul>
                  <li>
                  <strong>State-of-the-Art Security Protocols: </strong>
                  Our platform employs advanced encryption, sophisticated threat
                  detection systems, and effective spam filtering to ensure the
                  utmost security for your communications.
                  </li>
                 <li>
                 <strong>Unmatched Reliability: </strong>
                  With our meticulously designed infrastructure, we guarantee
                  minimal downtime, providing you with uninterrupted access to
                  your communication tools.
                 </li>
                 <li>
                 <strong>Intuitive User Experience: </strong>
                  Experience seamless email management and heightened
                  productivity through our intuitive interface, designed with
                  user-friendliness in mind.
                 </li>
                 <li>
                 <strong>Brand-Reflective Customization: </strong>
                  Establish a strong brand presence by using custom email
                  domains that align perfectly with your organization's
                  identity.
                 </li>
                 <li>
                 <strong>Effortless Collaboration: </strong>
                  Boost teamwork and efficiency with our integrated suite of
                  collaborative tools, including shared calendars, file sharing
                  capabilities, and collaborative editing features.
                 </li>
                 <li>
                 <strong>Round-the-Clock Assistance: </strong>
                  Our dedicated support team is available 24/7 to address any
                  queries or concerns, ensuring a smooth and hassle-free
                  experience for our users.
                 </li>
                </ul>

              
              </div>
            </div>
            <BusinessEmailBlock />
          </div>
        </div>
      </section>
  )
}

export default EmailBlock
